/* eslint-disable no-unused-vars */
export enum CommonColorCodes {
    // Primary Colors
    PRIMARY_1 = '#FBCBBB',
    PRIMARY_2 = '#F7A58D',
    PRIMARY_3 = '#F17F5F',
    PRIMARY_4 = '#EA5834',
    PRIMARY_5 = '#D13B1A',
    PRIMARY_6 = '#AF2D12',
    PRIMARY_7 = '#8D200C',
    PRIMARY_8 = '#691407',
    PRIMARY_9 = '#3B0802',
    PRIMARY_BG = '#FFF4F0',

    // Grey Scale Colors
    GREY_1 = '#F1F1EE',
    GREY_2 = '#D7D6D1',
    GREY_3 = '#BEBDB6',
    GREY_4 = '#A5A39C',
    GREY_5 = '#77756E',
    GREY_6 = '#6F6C62',
    GREY_7 = '#5A574E',
    GREY_8 = '#403D35',
    GREY_9 = '#2E2B24',
    GREY_BG = '#FBFAF9',

    // Semantic Colors
    SUCCESS_5 = '#1C891A',
    SUCCESS_7 = '#266F25',
    SUCCESS_BG = '#F5FAE7',

    // Critical Colors
    CRITICAL_5 = '#AE2121',
    CRITICAL_7 = '#940707',
    CRITICAL_BG = '#FFEFEB',

    // Warning Colors
    WARNING_5 = '#DD9222',
    WARNING_7 = '#A95F19',
    WARNING_BG = '#FEF9F1',

    // Info Colors
    INFO_5 = '#2775C4',
    INFO_6 = '#1C5A9C',
    INFO_7 = '#1C5A9C',
    INFO_BG = '#F2F7FC',

    // Tone Colors
    TONE_CRIMSON = '#761D3B',
    TONE_CRIMSON_300 = '#FAB4B8',
    TONE_CRIMSON_200 = '#F0D0D0',

    TONE_BRIGHT_BLUE = '#AED2F3',
    TONE_BRIGHT_BLUE_200 = '#E1EEFA',
    TONE_BRIGHT_BLUE_300 = '#C8E2FA',
    TONE_BRIGHT_BLUE_700 = '#7AB0E2',

    INK_700 = '#25223B',
    INK = '#35324A',
    INK_300 = '#8A8A9C',

    WHITE = '#FFFFFF',
    PRIMITIVE_WHITE = '#FFFFFF',
  }
